import gql from 'graphql-tag';

const GET_THIRD_PARTY_LAPSED_ACTIVITY = gql`
  query getSafegraphLapsedUser($params: ReportInput!) {
    lapsedUser(params: $params) {
      merchantId
      lapsedUserSegment
      numberOfCls
    }
  }
`;

export default GET_THIRD_PARTY_LAPSED_ACTIVITY;
